module.exports = __webpack_public_path__ + "static/media/cq_piu.82b09fb4.svg";